export interface ICommunity{
    id: number;
    description?: string;
    displayName: string;
    verticalId: number;
    subscriptionStatusId?: number;
    subscriptionStartDate?: Date | string;
    subscriptionEndDate?: Date | string;
    freeTrialStartDate?: Date | string;
    freeTrialEndDate?: Date | string;
    subscriptionStatusDerived?:string;
    daysRemainingInFreeTrial?: number;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipCode: string;
    coverImageBlob?: string;
    profileImageBlob?: string;
    galleryImagesBlob?: string;
    facebook?: string;
    instagram?: string;
    linkedin?: string;
    twitter?: string;
    website?: string;
    proposeFormLink?: string;
    latitude?: number;
    longitude?: number;
    country?: string;
    availableItems?:number;
    donatedItems?:number;
    totalItems?:number;
    airtableId?: string;
    contacts?: ICommunityContact[];
    formMasterId?: number;
    formSchema?: string;
}

export interface ICommunityContact{
    title?: string;
    email?: string;
    phone?: string;
}

export interface ICommunityContactTemp extends ICommunityContact{
    isExisting?: boolean;
    uiId?: string; // unique id
}
export interface IVolunteerShifts{
    id?: number;
    eventDate?:string;
    startTime?:string;
    endTime?:string;
    shiftTitle?:string;
    quantity?:number;
    donationCompletedCount?:number;
    startTimeAPM?: string;
    endTimeAPM?: string;
}

export interface ICommunityDto extends ICommunity{
    isGenerateSampleData: boolean;
    isOrganicSignUp: boolean;
}

export interface ICommunityPlaque{
    [key: number]: string;
}